import React from "react";

type Props = {};

const CreateAccount = (props: Props) => {
  return <div>CreateAccount</div>;
};

export default CreateAccount;
